<template>
  <div class="ninja-frame"
    :class="{
      'ninja-frame--horizontal': horizontalDisplay
    }"
  >
    <div class="ninja-frame__container">
      <ninja-loader :show="!triggered" />
      <div
        class="ninja-frame__container__transition ninja-frame__container__transition--top"
        :class="{
          'ninja-frame__container__transition--animate': isAnimating,
          ['ninja-frame__container__transition--top--' + direction]:
            isAnimating,
          ['ninja-frame__container__transition--top--' + direction + '--leaving']:
            isAnimating && leaving
        }"
      />
      <div
        class="ninja-frame__container__transition ninja-frame__container__transition--mid"
        :class="{
          'ninja-frame__container__transition--animate': isAnimating,
          ['ninja-frame__container__transition--mid--' + direction]:
            isAnimating,
          ['ninja-frame__container__transition--mid--' + direction + '--leaving']:
            isAnimating && leaving
        }"
      />
      <div
        class="ninja-frame__container__transition ninja-frame__container__transition--bottom"
        :class="{
          'ninja-frame__container__transition--animate': isAnimating,
          ['ninja-frame__container__transition--bottom--' + direction]:
            isAnimating,
          ['ninja-frame__container__transition--bottom--' + direction + '--leaving']:
            isAnimating && leaving
        }"
      />
      <div class="ninja-frame__container__item"
        v-touch:swipe="handleSwipe">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
/**
 * transition frame for prize section and small screen submissions
 */
import { TIME_TRANSITION_NINJA_FRAME_TRANSITION_SLIDE, TIME_TRANSITION_NINJA_FRAME_TRANSITION_DELAY } from '../../design-tokens/build/dictionary';


const ANIMATION_TIME = TIME_TRANSITION_NINJA_FRAME_TRANSITION_SLIDE
  + (TIME_TRANSITION_NINJA_FRAME_TRANSITION_DELAY * 2); // Last two transitions are delayed

const DELAY_TIME = 200;

export default {
  name: 'ninja-frame',
  props: {
    horizontalDisplay: {
      type: Boolean,
      default: false,
    },
    containerStyle: {
      required: false,
      default: () => ({})
    },
    triggered: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      direction: '',
      leaving: false,
      ready: true,
      isAnimating: false,
      timeouts: [],
    };
  },
  mounted() {
  },
  beforeDestroy() {
    // clean all timeouts
    this.timeouts.forEach(timeout => window.clearTimeout(timeout));
  },
  computed: {
  },

  watch: {

  },
  methods: {
    handleSwipe(direction) {
      console.log('frame swipe', direction);

      this.$emit('swipe', direction === 'right' ? 'next' : 'prev');
    },
    handleChange(direction, index) {
      this.$emit('change', direction, index);
    },

    /**
     * Animate the slide change
     * First 2 timeouts are equal to the animation time plus the longest delay (400ms + 200ms)
     * third timeout was needed so elements have time to
     * reset before the user can click to the next slide.
     *
     * NOTE TO MA: it would have been more flexible to use events instead of timers. I've added tokens so its a moot point
     *
     * @param {String} direction - prev or next
     */
    animateSlideChange(direction, index = null) {
      if (this.isAnimating || !this.ready) return;

      this.direction = direction;

      // start animation to cover frame
      this.isAnimating = true;
      this.$emit('busy', true);
      this.ready = false;

      this.timeouts.push(setTimeout(() => {
        // animation to cover is done, change the slide
        this.handleChange(direction, index);

        // start animation to reveal
        this.leaving = true;

        this.timeouts.push(setTimeout(() => {
          // animation to reveal is done
          // animation is done
          this.isAnimating = false;

          this.leaving = false;
          this.timeouts.push(setTimeout(() => {
            this.ready = true;
            this.$emit('busy', false);
            // reset delay, not sure what the length of this value was based on, orignally, Miles had300
          }, DELAY_TIME));

          // animation to reveal
        }, ANIMATION_TIME));
        // Animation to cover
      }, ANIMATION_TIME));
    },
  },

};
</script>

<style lang="scss">

// $time-transition-ninja-frame-transition-slide: 400ms;
// $time-transition-ninja-frame-transition-delay: 100ms;

.ninja-frame {
  position: relative;
  &::before {
    content: '';
    display: block;
    padding-bottom: percentage($number: $submission-thumbnail-ratio);
  }
  overflow: hidden;
  &--horizontal {
    margin: {
      left: auto;
      right: auto;
    }
    &::before {
      padding-bottom: percentage($number: 1 / $submission-thumbnail-ratio);
    }
    max-width: none;
  }

  &__container {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
    border-radius: $size-border-radius-ninja-frame-image-base;
    border: $size-border-ninja-frame-image-base solid $color-border-ninja-frame-image-base;
    &__item {
      width: 100%;
      height: 100%;
      background-size: cover;
      background-position: center center;
      background-repeat: no-repeat;
      z-index: 1;
    }
    &__transition {
      position: absolute;
      left: 0;
      width: 100%;
      z-index: 2;
      background-color: $color-background-ninja-frame-transition;
      height: 34%; // $size-height-ninja-frame-background;
      &--animate {
        transition: transform #{$time-transition-ninja-frame-transition-slide * 1} ease;
      }
      &--top {
        top: 0;
        left: -100%;
        transition-delay: $time-transition-ninja-frame-transition-delay * 0;
        transform: translate(0, 0);

        &--next {
          transform: translate(100%, 0);
          &--leaving {
            transform: translate(200%, 0);
          }
        }
        &--prev {
          right: -100%;
          left: auto;
          transform: translate(-100%, 0);
          &--leaving {
            transform: translate(-200%, 0);
          }
        }

      }
      &--mid {
        top: 50%;
        left: -100%;
        transform: translate(0, -50%);
        transition-delay: $time-transition-ninja-frame-transition-delay * 1;
        &--next {
          transform: translate(100%, -50%);
          &--leaving {
            transform: translate(200%, -50%);
          }
        }
        &--prev {
          right: -100%;
          left: auto;
          transform: translate(-100%, -50%);
          &--leaving {
            transform: translate(-200%, -50%);
          }
        }
      }
      &--bottom {
        bottom: 0;
        left: -100%;
        transition-delay: $time-transition-ninja-frame-transition-delay * 2;
        transform: translate(0, 0%);

        &--next {
          transform: translate(100%, 0%);
          &--leaving {
            transform: translate(200%, 0%);
          }
        }
        &--prev {
          right: -100%;
          left: auto;
          transform: translate(-100%, 0);
          &--leaving {
            transform: translate(-200%, 0);
          }
        }
      }
    }
  }
}
</style>
